import React from 'react'
import { App, Button } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { useSelector } from 'react-redux'
import rubricSelectors from '../../../../../../store/selectors/rubric.selectors'
import { useDeleteCategoryFromRubricMutation } from '../../../../../../store/apis/rubric.api'
import { openNotificationWithIcon } from '../../../../../../utils/notification.helper'
import { useAssignmentAccess } from '../../../../components/access/Access'
import { Perm, State } from '../../../../../../constants/assignment-permissions'

const DeleteCategoryButton = ({ onSuccess }) => {
    const { modal } = App.useApp()
    const editingCategoryId = useSelector(rubricSelectors.editingCategoryId)
    const editingRubricId = useSelector(rubricSelectors.editingRubricId)
    
    const [deleteCategory] = useDeleteCategoryFromRubricMutation()
    const { hasAccess, errorMessage } = useAssignmentAccess([
        Perm.CAN_EDIT, 
        State.NOT_PROCESSING, 
        State.NOT_MBA, 
        State.UNPUBLISHED, 
        State.LATEST,
        State.NO_SUBMISSIONS,
    ])

    const handleDelete = async () => {
        modal.confirm({
            title: 'Are you sure you want to delete this category?',
            icon: <ExclamationCircleOutlined />,
            content: 'This action cannot be undone. Submissions currently classified in this category will be marked as "unclassified".',
            okText: 'Delete',
            okType: 'danger',
            zIndex: 100000,
            onOk: async () => {
                const response = await deleteCategory({ rubricId: editingRubricId, categoryId: editingCategoryId })
                if ('data' in response) {
                    openNotificationWithIcon('success', 'Category deleted successfully')
                    onSuccess()
                }
            },
        })
    }

    return (
        <Button 
            danger 
            onClick={handleDelete} 
            disabled={!hasAccess}
            title={!hasAccess ? errorMessage : undefined}
        >
            Delete
        </Button>
    )
}

export default DeleteCategoryButton
